export const DEFAULT_ASPECT_RATIO = 16 / 9;
